import React from 'react';
import styles from './Gdpr.module.css';

const GDPRUpdating = () => {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        
        {/* Header */}
        <header className={styles.header}>
          <h1 className={styles.title}>🔄 GDPR Compliance Update in Progress</h1>
          <p className={styles.subtitle}>We're enhancing our data protection framework</p>
        </header>

        {/* Main Message */}
        <div className={styles.messageBox}>
          <div className={styles.messageIcon}>⚙️</div>
          <h2 className={styles.messageTitle}>Updating Our Compliance Documentation</h2>
          <p className={styles.messageText}>
            We're currently updating our General Data Protection Regulation (GDPR) 
            compliance documentation to provide better data protection and privacy controls. 
            Our team is working to ensure all policies reflect the latest requirements.
          </p>
        </div>

        {/* Status Indicators */}
        <div className={styles.statusSection}>
          <h3 className={styles.sectionTitle}>Current Compliance Status</h3>
          
          <div className={styles.statusGrid}>
            <div className={styles.statusItem}>
              <div className={styles.statusDotActive}></div>
              <div>
                <h4 className={styles.statusItemTitle}>GDPR Compliance</h4>
                <p className={styles.statusItemText}>Fully operational and active</p>
              </div>
            </div>

            <div className={styles.statusItem}>
              <div className={styles.statusDotUpdating}></div>
              <div>
                <h4 className={styles.statusItemTitle}>Documentation</h4>
                <p className={styles.statusItemText}>Being updated and enhanced</p>
              </div>
            </div>

            <div className={styles.statusItem}>
              <div className={styles.statusDotActive}></div>
              <div>
                <h4 className={styles.statusItemTitle}>Data Protection</h4>
                <p className={styles.statusItemText}>All measures fully operational</p>
              </div>
            </div>

            <div className={styles.statusItem}>
              <div className={styles.statusDotActive}></div>
              <div>
                <h4 className={styles.statusItemTitle}>User Rights</h4>
                <p className={styles.statusItemText}>Available and being processed</p>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline */}
        <div className={styles.timelineSection}>
          <h3 className={styles.sectionTitle}>Update Timeline</h3>
          
          <div className={styles.timeline}>
            <div className={styles.timelineItem}>
              <div className={styles.timelineDate}>November 2025</div>
              <div className={styles.timelineContent}>
                <h4 className={styles.timelineTitle}>Update in Progress</h4>
                <p className={styles.timelineText}>Reviewing and updating all compliance documents</p>
              </div>
            </div>

            <div className={styles.timelineItem}>
              <div className={styles.timelineDate}>March 2026</div>
              <div className={styles.timelineContent}>
                <h4 className={styles.timelineTitle}>Internal Review</h4>
                <p className={styles.timelineText}>Testing and validation of updated measures</p>
              </div>
            </div>

            <div className={styles.timelineItem}>
              <div className={styles.timelineDate}>April 2026</div>
              <div className={styles.timelineContent}>
                <h4 className={styles.timelineTitle}>Implementation</h4>
                <p className={styles.timelineText}>Rolling out enhanced privacy controls</p>
              </div>
            </div>

            <div className={styles.timelineItem}>
              <div className={styles.timelineDate}>April 2026</div>
              <div className={styles.timelineContent}>
                <h4 className={styles.timelineTitle}>Completion</h4>
                <p className={styles.timelineText}>Full update complete and published</p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Information */}
        <div className={styles.contactSection}>
          <h3 className={styles.sectionTitle}>Need Immediate Assistance?</h3>
          <p className={styles.contactText}>
            Our data protection team remains available during this update:
          </p>
          
          <div className={styles.contactGrid}>
            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>📧</div>
              <div>
                <h4 className={styles.contactItemTitle}>Email DPO</h4>
                <p className={styles.contactItemText}>dpo@rupayya.com</p>
                <small className={styles.contactItemNote}>For GDPR-specific inquiries</small>
              </div>
            </div>

            <div className={styles.contactItem}>
              <div className={styles.contactIcon}>🌐</div>
              <div>
                <h4 className={styles.contactItemTitle}>Online Portal</h4>
                <p className={styles.contactItemText}>privacy.rupayya.com</p>
                <small className={styles.contactItemNote}>Data subject requests</small>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className={styles.footer}>
          <div className={styles.footerNote}>
            <p className={styles.footerText}>
              <strong>Note:</strong> While we update our documentation, all existing GDPR compliance 
              measures remain fully operational. Your data protection is our priority.
            </p>
          </div>
          
          <div className={styles.commitment}>
            <p className={styles.commitmentText}>
              Rupayya is committed to maintaining the highest standards of data protection 
              and privacy throughout this update process.
            </p>
          </div>

          <div className={styles.updateInfo}>
            <p className={styles.updateDate}>Page last updated: November 19, 2025</p>
          </div>
        </footer>

      </div>
    </div>
  );
};

export default GDPRUpdating;